import { FunctionComponent, createContext, ReactNode, useState } from 'react';
interface LoadContextType {
  isLoad: boolean;
  setLoad: (is: boolean) => void;
}
const LoadContext = createContext<LoadContextType | null>(null);

interface LoadProviderProps {
  children: ReactNode;
}

const LoadProvider: FunctionComponent<LoadProviderProps> = (props) => {
  const [isLoad, setLoad] = useState<boolean>(false);

  return (
    <LoadContext.Provider value={{ isLoad, setLoad }}>
      {props.children}
    </LoadContext.Provider>
  );
};

export { LoadProvider, LoadContext };
